'use client';

import {cn} from '@/lib/utils';
import {useTranslations} from 'next-intl';
import {useEffect, useState} from 'react';
import {CarouselApi} from '../ui/carousel';
import SliderBase from './SliderBase';

export default function ArticleNote(Prop: {moduleOption: any}) {
  const {moduleOption} = Prop;
  const noteItems = moduleOption?.items || [];
  const [isOpenCarousel, setIsOpenCarousel] = useState<boolean>(false);

  let carouselApi: CarouselApi | null = null;
  const scrollToIndex = (childCarouselApi: CarouselApi) => {
    carouselApi = childCarouselApi;
  };

  const onOffCarousel = (index: number | null = null) => {
    setIsOpenCarousel(!isOpenCarousel);
    if (index !== null) {
      carouselApi?.scrollTo(index, true);
    }
  };

  let observerTimeline = setTimeout(() => {}, 100);
  useEffect(() => {
    if (observerTimeline) clearTimeout(observerTimeline);
    observerTimeline = setTimeout(() => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.remove('opacity-0');
            }, 100);
          }
        });
      });

      document.querySelectorAll('.observe').forEach(function (el) {
        observer.observe(el);
      });
    }, 100);
  }, []);

  const t = useTranslations('ArticleNote');

  return (
    <div className="float-right w-[35%] md:w-[30%] ml-2 mb-2 flex flex-col gap-2 article-note">
      <div
        className={cn(
          'fixed h-screen w-full bg-black/80 z-10 top-0 left-0 transition-opacity duration-500 ease-in-out ',
          isOpenCarousel ? 'opacity-100 ' : 'scale-0 opacity-0 '
        )}
        onClick={() => {
          onOffCarousel();
        }}
      >
        <div className="absolute right-5 top-5 p-2 z-20">
          <div className="">
            <div className="rounded-full bg-[#000000] w-8 h-8 flex justify-center items-center text-white cursor-pointer opacity-50 hover:opacity-100 transition-all duration-200">
              <span className="material-symbols outlined">close</span>
            </div>
          </div>
        </div>
        {/* carousel */}
        <SliderBase
          items={noteItems}
          options={{basis: 'none', noAutoPlay: true, fullWidth: true}}
          template={(note) => (
            <div className="flex flex-col items-center justify-center text-white ">
              <div className="h-screen w-full overflow-hidden flex justify-center items-center ">
                <div className="w-full flex flex-col justify-center items-center overflow-hidden">
                  <img
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    className="max-w-[80vw] max-h-[80vh] object-contain"
                    src={note.image}
                    alt={note.caption}
                  />
                  {note.caption && (
                    <div
                      className="w-[75vw] md:w-[60vw] max-w-[75vw] md:max-w-[1000px] mt-2 p-2 text-sm md:text-lg text-white bg-black/40 "
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      {note.caption}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
          scrollToIndex={scrollToIndex}
        ></SliderBase>
      </div>
      {noteItems.map(
        (
          item: {
            image: string;
            caption: string;
          },
          index: number
        ) => (
          <div
            key={index}
            title={t('showImage')}
            className="cursor-pointer"
            onClick={() => {
              onOffCarousel(index);
            }}
          >
            {/* font-size: 15px; line-height: 1.4rem; color: #888; */}
            <img src={item.image} alt={item.caption} />
            <div className="text-xs md:text-sm p-1 hyphens-auto tracking-tight text-gray-500">
              {item.caption}
            </div>
          </div>
        )
      )}
    </div>
  );
}
